import themeReducer from './themeReducer';
import sidebarReducer from './sidebarReducer';
import customizerReducer from './customizerReducer';

export {
  themeReducer,
  sidebarReducer,
    customizerReducer
}


// WEBPACK FOOTER //
// ./src/theme/redux/reducers/index.js